import { Icon } from "@fanduel/og-fe-library";
import cx from "classnames";
import { Maybe } from "graphql/jsutils/Maybe";
import { Hr_Runner } from "@/graphql/gql/graphql";
import useRunnerStats from "@/utils/hooks/useRunnerStats";
import {
  calcWinProbability,
  getRunnerPick,
  hasRaceStarted,
} from "@/utils/horseRacing";
import { HorseInfo, OddsBtn, SilkNum } from "../tableCells";
import styles from "./raceDetailsTable.module.scss";

interface RaceDetailsRunnerRowProps {
  runner: Hr_Runner;
  saddleColor: string | undefined;
  numberColor: string | undefined;
  numerator: number | undefined;
  denominator: number | undefined;
  trackDataSource: string | undefined;
  fdrLink: string;
  info?: string;
  isConsensusView: boolean;
  trackName: Maybe<string> | undefined;
  raceNumber: Maybe<string> | number | undefined;
  postTime: Maybe<string> | undefined;
}

const RaceDetailsRunnerRow = ({
  saddleColor,
  numberColor,
  runner,
  numerator,
  denominator,
  fdrLink,
  trackDataSource,
  isConsensusView,
  info,
  trackName,
  raceNumber,
  postTime,
}: RaceDetailsRunnerRowProps) => {
  const pick = getRunnerPick(runner, trackDataSource ?? "");
  const winProbability = calcWinProbability(numerator, denominator);
  const { top3Percentage, winPercentage, isError, isLoading } = useRunnerStats(
    runner.horseName ?? undefined
  );
  return (
    <tbody>
      <tr className={styles.dataRow}>
        <td
          className={cx(
            styles.silks,
            styles.sticky,
            runner.scratched && styles.scratched
          )}
        >
          <SilkNum
            saddleColor={saddleColor ?? undefined}
            numberColor={numberColor ?? undefined}
            runner={runner}
          />
        </td>
        <td
          className={cx(
            styles.horseInfo,
            styles.sticky,
            runner.scratched && styles.scratched
          )}
        >
          <HorseInfo
            analysis={isConsensusView && info ? info : undefined}
            pick={pick}
            saddleColor={saddleColor ?? undefined}
            numberColor={numberColor ?? undefined}
            runner={runner}
          />
        </td>
        <td>
          {Math.round(
            runner.handicapping?.snapshot?.normalisedPowerRating ?? 0
          )}
        </td>
        <td>
          {runner.handicapping?.speedAndClass?.normalisedSpeedRating &&
          runner.handicapping?.speedAndClass?.normalisedSpeedRating > 0
            ? runner.handicapping?.speedAndClass?.normalisedSpeedRating
            : "-"}
        </td>
        <td>{isError || isLoading ? "-" : winPercentage}</td>
        <td>{isError || isLoading ? "-" : top3Percentage}</td>
        <td>{winProbability}</td>
        <td>
          <OddsBtn
            runner={runner}
            numerator={numerator}
            denominator={denominator}
            fdrLink={fdrLink}
            trackName={trackName}
            raceNumber={raceNumber}
            disabled={hasRaceStarted(postTime)}
          />
        </td>
      </tr>
      {isConsensusView && info ? (
        <tr className={styles.analysisRow}>
          <td colSpan={8}>
            <div className={styles.analysisText}>
              <p className={styles.analysisTitle}>
                <Icon
                  iconName="icons.information"
                  iconColor="colorBaseGreyDarken4"
                />
                Analysis
              </p>
              <p>{info}</p>
            </div>
          </td>
        </tr>
      ) : (
        ""
      )}
    </tbody>
  );
};

export default RaceDetailsRunnerRow;
